var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0872 2.50358C12.3426 2.50358 11.7389 3.10724 11.7389 3.85189C11.7389 4.59654 12.3426 5.2002 13.0872 5.2002C13.8319 5.2002 14.4355 4.59654 14.4355 3.85189C14.4355 3.10724 13.8319 2.50358 13.0872 2.50358ZM10.3906 3.85189C10.3906 2.36259 11.5979 1.15527 13.0872 1.15527C14.5765 1.15527 15.7839 2.36259 15.7839 3.85189C15.7839 5.34119 14.5765 6.5485 13.0872 6.5485C11.5979 6.5485 10.3906 5.34119 10.3906 3.85189Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9974 7.22266C4.25275 7.22266 3.64909 7.82631 3.64909 8.57096C3.64909 9.31561 4.25275 9.91927 4.9974 9.91927C5.74205 9.91927 6.3457 9.31561 6.3457 8.57096C6.3457 7.82631 5.74205 7.22266 4.9974 7.22266ZM2.30078 8.57096C2.30078 7.08166 3.5081 5.87435 4.9974 5.87435C6.48669 5.87435 7.69401 7.08166 7.69401 8.57096C7.69401 10.0603 6.48669 11.2676 4.9974 11.2676C3.5081 11.2676 2.30078 10.0603 2.30078 8.57096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0872 11.9417C12.3426 11.9417 11.7389 12.5454 11.7389 13.29C11.7389 14.0347 12.3426 14.6383 13.0872 14.6383C13.8319 14.6383 14.4355 14.0347 14.4355 13.29C14.4355 12.5454 13.8319 11.9417 13.0872 11.9417ZM10.3906 13.29C10.3906 11.8007 11.5979 10.5934 13.0872 10.5934C14.5765 10.5934 15.7839 11.8007 15.7839 13.29C15.7839 14.7793 14.5765 15.9867 13.0872 15.9867C11.5979 15.9867 10.3906 14.7793 10.3906 13.29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43504 9.48817C6.6225 9.16648 7.03524 9.05766 7.35693 9.24512L11.4019 11.6047C11.7235 11.7921 11.8324 12.2049 11.6449 12.5265C11.4575 12.8482 11.0447 12.9571 10.723 12.7696L6.67809 10.4101C6.3564 10.2226 6.24758 9.80986 6.43504 9.48817Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6443 4.61522C11.832 4.93679 11.7234 5.34961 11.4019 5.53727L7.36236 8.0501C7.04079 8.23776 6.62798 8.1292 6.44031 7.80763C6.25265 7.48606 6.36121 7.07324 6.68278 6.88558L10.7223 4.37276C11.0438 4.18509 11.4567 4.29365 11.6443 4.61522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share-white.1510696a362be8274ac423b9f46b6c64.svg";
export { ForwardRef as ReactComponent };